/* eslint-disable import/prefer-default-export */
import { DigitalSubmission, QuestionTypeV2 } from '../../redux/types';

export const isAnswerEmpty = (s: DigitalSubmission) => {
  if (!s || s.answer === undefined || s.answer === null) {
    return true;
  }
  if (s.type === QuestionTypeV2.MultiChoice) {
    return !Object.values(s.answer).includes(true);
  }
  if (s.type === QuestionTypeV2.String) {
    return !s.answer.answer.trim();
  }
  if (s.type === QuestionTypeV2.NumberRange) {
    return s.answer === null || s.answer === undefined;
  }
  if (s.type === QuestionTypeV2.Ratio) {
    return !s.answer || !s.answer.length;
  }
  if (s.type === QuestionTypeV2.MultiChoiceWithText) {
    return !Object.values(s.answer).find((e) => e.selected === true);
  }
  return false;
};
